import * as React from 'react'
import { NiceNumber, NiceNumberWithCurrency } from '../../shared/UIFormatting'
import Project from '../../shared/Project'

import { ColumnFlexBox } from '../templates/Wrappers'



const RoundValues = (input: number) => Math.round(input / 1000) * 1000
const _exp = (input: number) => Math.exp((Math.log(1000) / 100) * input) / 10
const _log = (input: number) => Math.log(input * 10) / (Math.log(1000) / 100)

const NewInvestmentInput: React.FC<{ project: Project, setValue: (value: number) => void, defaultValue?: number }> = ({ project, setValue, defaultValue }) => {
    const MIN_INVESTEMENT = project.finance.minimumInvestment
    const MAX_INVESTMENT = project.finance.targetFunding - project.finance.currentFunding

    const [amount, setAmout] = React.useState<number>(defaultValue || MIN_INVESTEMENT)
    const [percent, setPercent] = React.useState<number>(0)
    const [disableFormatting, setDisableFormatting] = React.useState<boolean>(false)

    const percentToValue = (percent: number) => {
        const value = Math.round((MAX_INVESTMENT * ((percent - 0.1) / 100)) + MIN_INVESTEMENT)
        if(value>MAX_INVESTMENT) return MAX_INVESTMENT
        else return value
    }
    const valueToPercent = (value: number) => ((value - MIN_INVESTEMENT) / MAX_INVESTMENT) * 100

    const handleInputTextChange = (value: string) => {
        let formattedValue: string | number = value
        formattedValue = formattedValue.split('.').join('')
        formattedValue = Number(formattedValue)
        if (isNaN(formattedValue)) return
        setAmout(formattedValue)

        if (formattedValue <= MIN_INVESTEMENT) setPercent(0)
        else if (formattedValue >= MAX_INVESTMENT) setPercent(100)
        else setPercent(_log(valueToPercent(formattedValue)))
    }
    React.useEffect(() => {
        setValue(amount)
    }, [amount])

    const arthemetics = (input: number) => {
        const regInput = _exp(input)
        const inputAmount = percentToValue(regInput)
        setAmout(RoundValues(inputAmount))
        setPercent(input)
    }

    return (
        <ColumnFlexBox>
            <input type="text" value={disableFormatting ? amount : NiceNumberWithCurrency(amount)}
                onFocus={() => setDisableFormatting(true)} onBlur={() => setDisableFormatting(false)}
                onChange={(e) => handleInputTextChange(e.target.value)} />
            <input type="range"
                onChange={(e) => arthemetics(Number(e.target.value))}
                value={percent} max={100} />
        </ColumnFlexBox>
    )
}

export default NewInvestmentInput